module.exports = "https://web-assets.ifttt.com/packs/media/icons/wind-b0463d5c.png";